import { ListFilter } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@monksflow/monks-ui';

export interface ColumnFilterOption {
  value: string;
  label: string;
}

interface ColumnFilterMenuProps {
  /** Accessible label for the trigger, e.g. "Filter by status". */
  label: string;
  options: ColumnFilterOption[];
  selected: string[];
  onChange: (next: string[]) => void;
}

export const ColumnFilterMenu = ({ label, options, selected, onChange }: ColumnFilterMenuProps) => {
  const isActive = selected.length > 0;

  const toggle = (value: string) => {
    onChange(selected.includes(value) ? selected.filter((v) => v !== value) : [...selected, value]);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={label}
          // Stop the click from reaching the header (which may handle sorting).
          onClick={(event) => event.stopPropagation()}
          className={`flex size-5 items-center justify-center rounded-sm outline-none transition-colors hover:text-gray-950 dark:hover:text-foreground ${
            isActive
              ? 'text-gray-950 dark:text-foreground'
              : 'text-gray-600 dark:text-muted-foreground'
          }`}
        >
          <ListFilter className="size-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-44">
        {options.map((option) => (
          <DropdownMenuCheckboxItem
            key={option.value}
            checked={selected.includes(option.value)}
            onCheckedChange={() => toggle(option.value)}
            // Keep the menu open so multiple values can be toggled.
            onSelect={(event) => event.preventDefault()}
          >
            {option.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

ColumnFilterMenu.displayName = 'ColumnFilterMenu';
